import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Modal, Select, Checkbox } from 'antd';

const HandwritingNotes = ({ form, formData, setFormData, setAutoStop, setLoader, modelSubmit, setModelSubmit }) => {
    const [notes, setNotes] = useState('');
    const [reasonWalkoutNote, setReasonWalkoutNote] = useState(false);
    const [visible, setVisible] = useState(false);

    const walkoutData = [
        { id: "Customer has found a better option", name: 'Customer has found a better option' },
        { id: "Customer may have received a better offer elsewhere", name: 'Customer may have received a better offer elsewhere' },
        { id: "Customer unwilling to wait for the product, despite checking FBO", name: 'Customer unwilling to wait for the product, despite checking FBO' },
        { id: "Customer not convinced by our sales pitch", name: 'Customer not convinced by our sales pitch' },
        { id: "Customer has postponed the purchase plan", name: 'Customer has postponed the purchase plan' },
        { id: "Loan limit not approved/unavailable", name: 'Loan limit not approved/unavailable' },
        { id: "Customer is purchasing in Sangeetha. No walkout.", name: 'Customer is purchasing in Sangeetha. No walkout.' },
        { id: "Other", name: 'Other' },
    ];

    const onChangeReasonWalkout = (value) => {
        setReasonWalkoutNote(value === "Other");
    };

    const handleCancel = () => {
        setVisible(false);
    };

    const handleSubmit = () => {
        const aboutTangoEyeId = localStorage.getItem('tango-token');

        setFormData(prev => ({
            ...prev,
            notes,
            about_tango_eye_id: aboutTangoEyeId,
        }));
        setVisible(true);
    };

    const handleModelSubmit = async (values) => {
        if (!values.note_to_customer && !values.tp_dp_check) {
            message.error("Please select at least one checkbox option");
            return;
        }

        setAutoStop(true);
        const token = localStorage.getItem('sectionId');
        const modifiedValue = { ...values, token };

        setFormData(prev => ({
            ...prev,
            ...modifiedValue,
            product_viewed: formData.product_viewed || [],
        }));
        setModelSubmit(true);
        setLoader(true);
        setVisible(false);
    };

    return (
        <>
            <Card
                style={{
                    marginBlock: "24px",
                    borderRadius: 24,
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.05)',
                    padding: 12,
                }}
                styles={{ header: { paddingLeft: 15 } }}
                title="Notes"
            >
                <div style={{ marginBottom: 16 }}>
                    {/* <label style={{ fontWeight: 500 }}>Notes</label> */}
                    <Input.TextArea
                        rows={8}
                        placeholder="Write the Notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />
                </div>

                <Button type="primary" onClick={handleSubmit}>
                    Submit
                </Button>
            </Card>

            <Modal open={visible} centered title="Customer Information" width={600} closable footer={false} keyboard={false} onCancel={handleCancel} maskClosable={false}>
                <Form layout="vertical" onFinish={handleModelSubmit} form={form}>
                    <Form.Item name="customer_name" label="Customer Name" rules={[{ required: true, message: 'Please enter the Customer Name' }]}>
                        <Input placeholder="Enter the Customer Name" />
                    </Form.Item>

                    <Form.Item name="customer_mobile" label="Customer Mobile" rules={[{ required: true, message: 'Please enter the Customer Mobile Number', pattern: /^[0-9]{10}$/ }]} maxLength={10}>
                        <Input placeholder="Enter the Customer Mobile Number" />
                    </Form.Item>

                    <Form.Item name="reason_walkout" label="What is the reason for customer walkout?" rules={[{ required: true, message: 'Please Choose any one option' }]}>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Please choose the Product"
                            options={walkoutData.map(data => ({ label: data.name, value: data.id }))}
                            optionFilterProp="children"
                            filterOption={(input, option) => ((option?.label).toLowerCase() ?? '').includes(input.toLowerCase())}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            showSearch
                            notFoundContent={null}
                            allowClear
                            onChange={onChangeReasonWalkout}
                        />
                    </Form.Item>

                    {reasonWalkoutNote && (
                        <Form.Item name="reason_walkout_notes" label="Other Reason Notes" rules={[{ required: true, message: 'Please write your notes!' }]}>
                            <Input.TextArea rows={6} placeholder="Write the Notes" />
                        </Form.Item>
                    )}

                    <Form.Item name="employee_id" label="Employee ID" rules={[{ required: true, message: 'Please enter the Employee ID', pattern: /^[0-9]+$/ }]} maxLength={5}>
                        <Input placeholder="Enter the Employee ID" />
                    </Form.Item>

                    <Form.Item name="note_to_customer" initialValue={true} valuePropName="checked">
                        <Checkbox>
                            Do u want to send the notepad to customer
                        </Checkbox>
                    </Form.Item>

                    <Form.Item name="tp_dp_check" initialValue={true} valuePropName="checked">
                        <Checkbox>
                            I have pitched TP, DP and Device genie as per the script given to me
                        </Checkbox>
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={modelSubmit}>
                            {modelSubmit ? `Please wait....` : `Submit`}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default HandwritingNotes;
